export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9239.d2b40f00.jpg";